import { useEffect, useRef } from 'react';
import * as symbolUtils from '@arcgis/core/symbols/support/symbolUtils';

// Render custom symbol preview as HTML element
export const FeatureSymbol = ({
  symbol,
}: {
  symbol?: __esri.SymbolUnion | null;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && symbol) {
      containerRef.current.innerHTML = '';

      symbolUtils
        .renderPreviewHTML(symbol, {
          size: 16,
        })
        .then((element) => {
          if (!element) return;

          containerRef.current?.appendChild(element);
        });
    }
  }, [symbol]);

  return <div ref={containerRef} />;
};
